import { render, staticRenderFns } from "./ReferralDetailsView.vue?vue&type=template&id=432ecb4d&scoped=true&"
import script from "./ReferralDetailsView.vue?vue&type=script&lang=ts&"
export * from "./ReferralDetailsView.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralDetailsView.vue?vue&type=style&index=0&id=432ecb4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432ecb4d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/rensvannijnatten/source/repos/AZNConnect/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib'
installComponents(component, {VLayout})
